export function handleScoopAjaxError(error, customMessage) {
    if (error.response.status === 422) {
        for (const key in error.response.data.errors) {
            window.toastr.error(error.response.data.errors[key], error.response.data.message);
        }
    } else if (error.response.status === 403) {
        window.toastr.error('You are not allowed to perform this action', customMessage || error, {timeOut: 5000});
        console.log(error.response);
    } else {
        window.toastr.error(error.response.data.message || 'An error occured', customMessage || error, {timeOut: 5000});
        console.log(error.response);
    }
}